/**
 * Quantos quadradinhos pintar numa linha do funil (estilo gráfico de
 * contribuições do GitHub). `full` = cheios; `partial` = 1 mais claro quando
 * sobra uma fração relevante. Qualquer valor > 0 aparece com pelo menos um
 * quadrado — "1 indicação" nunca pode parecer zero.
 */
export function filledCells(value: number, top: number, cells: number): { full: number; partial: number } {
  if (!(value > 0) || !(top > 0) || cells <= 0) return { full: 0, partial: 0 };
  const exact = Math.min(1, value / top) * cells;
  const full = Math.floor(exact);
  const rest = exact - full;
  if (full === 0) return { full: 0, partial: 1 };
  return { full, partial: full < cells && rest >= 0.25 ? 1 : 0 };
}
